module.exports = __webpack_public_path__ + "static/media/ribeye.75613b2f.jpg";